module.exports = __webpack_public_path__ + "img/edge-cases.15fc40c9.png";